import React from 'react'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/core/styles'
import { Box, Typography } from '@material-ui/core'

// Styles for this component.
const useStyles = makeStyles(theme => ({
  root: {
    overflowY: 'auto',
    overflowX: 'hidden',
    height: '100%',
    width: '100%',
  },
}))

const PanelBody = ({ title, children, ...props }) => {
  const classes = useStyles()

  return (
    <Box className={clsx(classes.root, 'panel-body')}>
      {children}
    </Box>
  )
}

export default PanelBody
